import React from "react";

import { getRouteByCategoryId } from "../../../helpers/getRouteByCategoryId";

import {
  Button,
  ButtonContainer,
  Card,
  CardHeader,
  Category,
  CategoryContainer,
  Circle,
  Description,
  Divider,
  Icon,
  Meeting,
  Price,
  PriceContainer,
  Tag,
  Title,
  TitleContainer,
} from "./styles";

type TTariffCard = {
    category: string
    categoryId?: number
    title: string
    description: string
    duration: string
    price: number
    min_price: number
    max_price: number
    tag: string
    tabType: string
    strMaxLength: number
}

export const TariffCard: React.FC<TTariffCard> = ({
  category,
  categoryId,
  title,
  description,
  duration,
  price,
  min_price,
  max_price,
  tag,
  tabType,
  strMaxLength,
}) => {

    const price_ = new Intl.NumberFormat("ru-RU").format(price);
    let min_price_ = new Intl.NumberFormat("ru-RU").format(min_price)
    let max_price_ = new Intl.NumberFormat("ru-RU").format(max_price)

    if (price_ > '0') {
        min_price_ = '0'
        max_price_ = '0'
    }

  return (
    <Card>
      <CardHeader tabType={tabType}/>
      <CategoryContainer>
        <Circle tabType={tabType}/>
        <Category>{category}</Category>
      </CategoryContainer>
      <TitleContainer>
        <Title>{title}</Title>
      </TitleContainer>
      <Divider/>
      <Description>{description}</Description>
      <Divider/>
      <PriceContainer>
        <Meeting>{duration}</Meeting>
        <Price textLength={strMaxLength}>
            {price ? price_ : ''}
            {min_price_ != '0' ? ' от ' + min_price_ : ''}
            {max_price_ != '0' ? ' до ' + max_price_ : ''} ₽</Price>
        <Tag>{tag}</Tag>
      </PriceContainer>
      <ButtonContainer>
        <Button to={getRouteByCategoryId(categoryId)}>
          <span>Подробнее</span>
          <Icon/>
        </Button>
      </ButtonContainer>
    </Card>
  )
};

